var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.59685 0 0 5.59685 0 12.5C0 19.4039 5.59685 25 12.5 25C19.4039 25 25 19.4047 25 12.5C25 5.59685 19.4039 0 12.5 0ZM12.5 22.6562C6.89066 22.6562 2.34379 18.1093 2.34379 12.5C2.34379 6.89066 6.89066 2.34379 12.5 2.34379C18.1093 2.34379 22.6562 6.89066 22.6562 12.5C22.6562 18.1093 18.1093 22.6562 12.5 22.6562ZM12.5008 5.48201C11.6055 5.48201 10.9281 5.94923 10.9281 6.70389V13.6258C10.9281 14.3812 11.6054 14.8468 12.5008 14.8468C13.3742 14.8468 14.0735 14.3617 14.0735 13.6258V6.70389C14.0734 5.96714 13.3742 5.48201 12.5008 5.48201ZM12.5008 16.4063C11.6406 16.4063 10.9406 17.1063 10.9406 17.9671C10.9406 18.8265 11.6406 19.5266 12.5008 19.5266C13.3609 19.5266 14.0602 18.8265 14.0602 17.9671C14.0601 17.1062 13.3609 16.4063 12.5008 16.4063Z",
    fill: "#FF1C26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.503d9b9cb15084170face7b466633416.svg";
export { ForwardRef as ReactComponent };